import create from "zustand";

export interface Label {
  id: string;
  name: string;
  label: string;
}

interface ModalState {
  id?: string;
  idDelete?: string;
  ids?: string[];
  names?: string[];
  isOpen: boolean;
  isOpenImport: boolean;
  isOpenImportTalhoes: boolean;
  importTalhoesObject: any;
  isEditing: boolean;
  isCopying: boolean;
  isCopyingObject: Label[] | [];
  isDeleting: boolean;
  isDeletingMultiple: boolean;
  isVinculo: boolean;
  vinculoIndex: number;
  vinculoSequencia: number;
  isOperacoesOpen: boolean;
  isModalDeleteOperacoes: boolean;
  isBlockingFields: boolean;
  form: any;
  setId: (args: string) => void;
  setIdDelete: (args: string) => void;
  setIds: (args: string[]) => void;
  setNames: (args: string[]) => void;
  setIsOpen: (args: boolean) => void;
  setIsOpenImport: (args: boolean) => void;
  setIsOpenImportTalhoes: (args: boolean) => void;
  setImportTalhoesObject: (args: any) => void;
  setIsEditing: (args: boolean) => void;
  setIsCopying: (args: boolean) => void;
  setIsCopyingObject: (args: Label[]) => void;
  setIsDeleting: (args: boolean) => void;
  setIsDeletingMultiple: (args: boolean) => void;
  setIsVinculo: (args: boolean) => void;
  setIsVinculoIndex: (args: number) => void;
  setVinculoSequencia: (args: number,) => void;
  setIsOperacoesOpen: (args: boolean) => void;
  setIsModalDeleteOperacoes: (args: boolean) => void;
  setIsModalDeleteOperacoesForm: (form: any) => void;
  setIsBlockingFields: (args: boolean) => void;
}

const useModal = create<ModalState>((set) => ({
  id: '',
  idDelete: '',
  ids: [],
  names: [],
  classe: null,
  isOpen: false,
  isOpenImport: false,
  importTalhoesObject: {},
  isOpenImportTalhoes: false,
  isEditing: false,
  isCopying: false,
  isCopyingObject: [],
  isDeleting: false,
  isDeletingMultiple: false,
  isVinculo: false,
  vinculoIndex: -1,
  vinculoSequencia: -1,
  isOperacoesOpen: false,
  isModalDeleteOperacoes: false,
  isBlockingFields: false,
  form: {},
  setId: (id) => {
    set(state => ({ id }));
  },
  setIdDelete: (idDelete) => {
    set(state => ({ idDelete }));
  },
  setIds: (ids) => {
    set(state => ({ ids }));
  },
  setNames: (names) => {
    set(state => ({ names }));
  },
  setIsOpen: (isOpen) => {
    set(state => ({ isOpen }));
  },
  setIsOpenImport: (isOpenImport) => {
    set(state => ({ isOpenImport }));
  },
  setIsOpenImportTalhoes: (isOpenImportTalhoes) => {
    set(state => ({ isOpenImportTalhoes }));
  },
  setImportTalhoesObject: (importTalhoesObject) => {
    set(state => ({ importTalhoesObject }));
  },
  setIsEditing: (isEditing) => {
    set(state => ({ isEditing }));
  },
  setIsDeleting: (isDeleting) => {
    set(state => ({ isDeleting }));
  },
  setIsDeletingMultiple: (isDeletingMultiple) => {
    set(state => ({ isDeletingMultiple }));
  },
  setIsVinculo: (isVinculo) => {
    set(state => ({ isVinculo }));
  },
  setIsVinculoIndex: (vinculoIndex) => {
    set(state => ({ vinculoIndex }));
  },
  setIsCopying: (isCopying) => {
    set(state => ({ isCopying }));
  },
  setIsCopyingObject: (isCopyingObject) => {
    set(state => ({ isCopyingObject }));
  },
  setVinculoSequencia: (vinculoSequencia) => {
    set(state => ({ vinculoSequencia }));
  },
  setIsOperacoesOpen: (isOperacoesOpen) => {
    set(state => ({ isOperacoesOpen }));
  },
  setIsModalDeleteOperacoes: (isModalDeleteOperacoes) => {
    set(state => ({ isModalDeleteOperacoes }));
  },
  setIsModalDeleteOperacoesForm: (form) => {
    set(state => ({ form }));
  },
  setIsBlockingFields: (isBlockingFields) => {
    set(state => ({ isBlockingFields }));
  },
}));

export default useModal;
